export const app = {
    typeDevice:     process.env.REACT_APP_TYPE_DEVICE || '',
    uri:            process.env.REACT_APP_BASE_URL || '',
    debug:          process.env.REACT_APP_DEBUG === 'true'
}